"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamSetupService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class TeamSetupService {
    /**
     * @returns TeamSetupConfig The team setup configuration data
     * @throws ApiError
     */
    static getSetupConfig() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/team/setup-config',
        });
    }
}
exports.TeamSetupService = TeamSetupService;
